import { reactive } from "vue";

const STORAGE_KEY = "debugInspectorEnabled";

let _idCounter = 0;

export const debugState = reactive({
  enabled: localStorage.getItem(STORAGE_KEY) === "true",
  topZ: 10000,
  activeId: null
});

export function toggleDebug() {
  debugState.enabled = !debugState.enabled;
  localStorage.setItem(STORAGE_KEY, debugState.enabled);
}

export function raiseToTop() {
  return ++debugState.topZ;
}

export function createId() {
  return ++_idCounter;
}

export function setActive(id) {
  debugState.activeId = id;
}
